import { fNumber } from '@aibees/shared/utils';
import { CurrentPlanVariant } from '../../current-plan-banner/types';

const CUSTOM_MESSAGE =
  "You're on a custom agreement. Switching to any plan below will end your custom agreement.";

function formatCreditsShort(requestCount: number): string {
  if (!requestCount) return '';
  if (requestCount >= 1000) {
    return `${fNumber(requestCount / 1000)}K credits/mo`;
  }
  return `${fNumber(requestCount)} credits/mo`;
}

export function buildMessage(
  variant: CurrentPlanVariant,
  name: string,
  requestCount: number,
  price: number
): string {
  if (variant === CurrentPlanVariant.LEGACY) {
    const credits = formatCreditsShort(requestCount);
    return `${name} is your current plan — ${credits} · $${price}/mo. Keep it or explore plans below.`;
  }
  return CUSTOM_MESSAGE;
}
